import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { StakeholderConsolidatedPosition } from '../../types/stakeholder.types';
import { useAppQuery } from '../use-app-query.hook';

export const useConsolidatedPosition = ({
  companyId,
  enabled = true,
  stakeholderId,
}: {
  companyId: string;
  enabled?: boolean;
  stakeholderId: string;
}) => {
  const { data, isLoading } = useAppQuery({
    queryKey: [QueryKey.GET_STAKEHOLDER_CONSOLIDATED_POSITION, companyId, stakeholderId],
    queryFn: () =>
      ApiService.get<StakeholderConsolidatedPosition>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'stakeholders', stakeholderId, 'consolidated-position'],
      }),
    enabled: enabled && !!companyId && !!stakeholderId,
  });

  return {
    consolidatedPosition: data?.shareClasses,
    isLoading,
  };
};
